import { BetStatusId } from '@/models/bet/status/id';
import { Image } from '@starsoft/common/components';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import useTranslation from 'next-translate/useTranslation';
import { GameReportBetProps } from '../props';
import BetDisplaySkeleton from './Skeleton';
import styles from './styles.module.scss';
import { Decimal } from '@starsoft/common/services/Decimal';

export default function BetDisplay({
  bet,
  isPending,
  isSingleBet,
}: GameReportBetProps) {
  const { t } = useTranslation('game-report');
  const won: boolean =
    bet?.status?.id?.toString() == BetStatusId.Won?.toString();

  function getPayout(): string {
    return bet.payout?.toNumberString();
  }

  if (isPending) {
    return <BetDisplaySkeleton />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__column}>
        <span className={styles.container__title}>{t('bet_amount_label')}</span>

        <span className={styles.container__value}>
          <Image
            className={styles.container__value__coin}
            alt="coin"
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${bet?.coin?.image}`}
          />
          {WalletService.maskCurrency({
            amount: getMoneyOrAmount(bet?.amount) ?? 0,
            coin: bet?.coin,
          })}
        </span>
      </div>

      <div className={styles.container__divider} />

      <div className={styles.container__column}>
        <span className={styles.container__title}>{t('multiplier_label')}</span>

        <span className={styles.container__value}>
          {Decimal.fromSubunits(bet?.multiplier as unknown as bigint, {
            scale: 4,
          }).toNumberString()}
          x
        </span>
      </div>

      {!isSingleBet && (
        <>
          <div className={styles.container__divider} />
          <div className={styles.container__column}>
            <span className={styles.container__title}>{t('profit_label')}</span>
            <span
              className={`${styles.container__value} ${won ? styles['container__value--won'] : styles['container__value--lost']}`}
            >
              <Image
                className={styles.container__value__coin}
                alt="coin"
                src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${bet?.coin?.image}`}
              />
              {!won && '-'}
              {getPayout()}
            </span>
          </div>
        </>
      )}
    </div>
  );
}
